module.exports = __webpack_public_path__ + "img/FORD.dc5a0c53.svg";